/**
 * Serializes JSON-LD and escapes `<` to prevent XSS when embedded in HTML.
 */
export const serializeJsonLd = (data: unknown): string =>
  JSON.stringify(data).replace(/</g, '\\u003c');
